import Typography from 'components/atoms/Typography';
import Skeleton from 'react-loading-skeleton';
import classNames from 'classnames';
import { ConversationPrompts } from 'utils/gloo-types';
import { useIsMobile } from 'utils/hooks';
import ConversationPromptCard from 'components/molecules/ConversationPromptCard';
import SkeletonWrap from 'components/organisms/SkeletonWrap';

export interface PreviewYourPromptProps {
  prompt?: Partial<ConversationPrompts>;
  isLoading?: boolean;
}

const PreviewYourPrompt = ({ prompt, isLoading }: PreviewYourPromptProps) => {
  const isMobile = useIsMobile();

  return (
    <div className={classNames('flex-1 border-glooNavy-100', isMobile ? 'pt-6 mt-6 pb-8 border-t' : 'border-l py-8')}>
      <div className={classNames('flex justify-between items-center', !isMobile && 'px-8')}>
        <Typography variant={isMobile ? 'h4' : 'h2'} className="text-neutral-700">
          Preview Your Prompt
        </Typography>
      </div>
      <div className={classNames('mt-4 overflow-y-auto overflow-x-visible', !isMobile && 'px-4')}>
        <SkeletonWrap
          skeleton={<Skeleton height={60} className="my-8" />}
          isLoading={isLoading}
          content={<ConversationPromptCard prompt={prompt} isInPreview key={0} highlightedTopicIds={[]} />}
        />
      </div>
    </div>
  );
};

export default PreviewYourPrompt;
